module.exports = __webpack_public_path__ + "static/media/chinese_new_year_2022.7dd9f4d2.png";